import getCollectionData from "../../utils/getCollectionData";
import getDocumentData from "../../utils/getDocumentData";
import runBatch from "../../utils/runBatch";

import { CommentRef } from "./types/Comment";

export default async function deleteComment(firebase, { comment }) {
	const channelId = comment.channels?.[0];

	const channel = await getDocumentData(
		channelId && firebase.firestore().collection("discussionChannels").doc(channelId),
	);

	const isLastComment = comment.id === channel?.lastComment?.id;

	let lastComment = null;

	if (isLastComment) {
		const lastComments = await getCollectionData(
			firebase
				.firestore()
				.collection("comments")
				.where("channels", "array-contains", channelId)
				.where("deleted", "==", false)
				.orderBy("created", "desc")
				.limit(2),
		);

		lastComment = lastComments[1];
	}

	return runBatch(firebase, (batch) => {
		batch.update(comment.ref, { deleted: true });

		if (isLastComment) {
			batch.update(channel.ref, { lastComment: lastComment ? CommentRef.parse(lastComment) : null });
		}
	});
}
